import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'notificacion',
  standalone: false,
  templateUrl: 'notificacion.component.html',
  styleUrls: ['notificacion.component.scss']
})

export class NotificacionComponent implements OnInit {

  @Input()
  notificationItem;

  constructor() {
  }

  ngOnInit() {
  }
}
